import React from 'react';
import type { DeviceType } from '@benzinga/device-utils';
import classNames from 'classnames';

const Primis = React.lazy(() =>
  import('@benzinga/ads').then(module => {
    return { default: module.Primis };
  }),
);

interface PrimisVideoProps {
  attrs?: {
    data?: {
      id: string;
      device_type: 'all' | 'desktop' | 'mobile';
    };
  };
  deviceType?: DeviceType;
  type: 'default' | 'sidebar';
}

export const PrimisBlock: React.FC<PrimisVideoProps> = ({ attrs, deviceType, ...props }) => {
  const primisId = attrs?.data?.id;
  if (attrs?.data?.device_type === 'mobile' && deviceType !== 'mobile') return null;
  else if (attrs?.data?.device_type === 'desktop' && deviceType === 'mobile') return null;

  const isSidebar = props.type === 'sidebar';

  return (
    <div
      className={classNames('flex items-center justify-center my-1', {
        'min-h-[170px]': isSidebar,
      })}
    >
      <Primis id={primisId} />
    </div>
  );
};
